const autocomplete = [
    {
        id: 1,
        suggestion: "elon musk",
    },
    {
        id: 2,
        suggestion: "elon musk twitter",
    },
    {
        id: 3,
        suggestion: "elon musk facebook",
    },
    {
        id: 4,
        suggestion: "coffee",
    },
    {
        id: 5,
        suggestion: "elon musk networth",
    },
    {
        id: 6,
        suggestion: "elon musk age",
    }, 
    {
        id: 7,
        suggestion: "elon musk twitter",
    },
    {
        id: 8,
        suggestion: "elon musk amber heard",
    },
    {
        id: 9,
        suggestion: "elon musk age",
    },  
    {
        id: 10,
        suggestion: "elon musk wife"
    },
    {
        id: 12,
        suggestion: "coffee near me"
    },
    {
        id: 13,
        suggestion: "coffee machine"
    },
    {
        id: 14,
        suggestion: "coffee filter"
    },
    {
        id: 15,
        suggestion: "coffee hair color"
    },
    {
        id: 16,
        suggestion: "coffee: is it harmful?"
    },
    {
        id: 17,
        suggestion: "coffee mugs"
    },
    {
        id: 18,
        suggestion: "coffee for free"
    },
    {
        id: 19,
        suggestion: "coffee for sale"
    },
    {
        id: 20,
        suggestion: "coffee anxiety"
    }

]

export default autocomplete;